const { atom } = require("jotai");

const newSeriesAtom = atom({})
const newUserAtom = atom({})
const nftCollectionsAtom = atom(null)
const isNftValid = atom({})
export { newSeriesAtom, newUserAtom, nftCollectionsAtom, isNftValid }